import {Component, EventEmitter, Input, OnInit, Output, ViewChild, ViewEncapsulation} from "@angular/core";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import { CardService } from "../../services/card.service";
import { Utility } from "../../../shared/utility/utility";
import { CustomValidators } from "../../../shared/utility/custom-validator";
import { DynamicFieldComponent } from "../dynamic-field/dynamic-field.component";
import { EmitterService } from "../../../services/emitter.service";

@Component({
  selector: "app-dynamic-form",
  templateUrl: "./dynamic-form.component.html",
  styleUrls: ["./dynamic-form.component.scss"],
  encapsulation: ViewEncapsulation.None
})
export class DynamicFormComponent implements OnInit {
  @Output() onSubmit = new EventEmitter();
  @Input() fields: any[] = [];
  validationClass;
  form: FormGroup;
  @Input() oneLineInputFields = []
  @ViewChild(DynamicFieldComponent) childDynamicFieldComponent;
  @Output() updateFormData = new EventEmitter<any>();
  isSubmitted = false;
  constructor(private cardService:CardService, private utils:Utility, 
    public CustomValidators:CustomValidators,private emitterService:EmitterService) { }
 
  ngOnInit() {
    this.emitterService.emitSubmitFormClick$.subscribe((status)=>{
      this.isSubmitted = true;
    })
    this.emitterService.addNewCardClick$.subscribe((state)=>{
      this.emitterService.broadCastCreditCardFormData(this.form);
    })
    let fieldsCtrls = {};
    for (let f of this.fields) {
      if (f.type != 'checkbox') {
        fieldsCtrls[f.name] = new FormControl(f.value || '', this.getValidators(f))
      } else {
        let opts = {};
        for (let opt of f.options) {
          opts[opt.key] = new FormControl(opt.value);
        }
        fieldsCtrls[f.name] = new FormGroup(opts);
      }
    }
    this.form = new FormGroup(fieldsCtrls);
    this.updateFormData.emit(this.form);
    this.emitterService.broadCastCreditCardFormData(this.form);
    this.form.valueChanges.subscribe(val => {
      this.updateFormData.emit(this.form);
     });
  }
  isEqualLastFieldName(fieldName){
    if(this.oneLineInputFields[this.oneLineInputFields.length-1] == fieldName){
      return true;
    }
    return false;
  }

  getValidators(f){
    if(f.name == "fullName"){
      return [this.CustomValidators.validName(2, 30)];
    }else if(f.name == 'cardNumber'){
      return [this.cardService.checkCredicardValidation(f.minLength, f.maxLength)]
    }else if(f.name == 'cardCvv'){
      return [this.cardService.checkCvvValidation(f.minLength, f.maxLength)]
    }else if(f.name == 'cardExpiry'){
      return [this.cardService.expCardData(f.minLength, f.maxLength)]
    }else
      return [Validators.required]
  }
  shouldShowErrors(fieldName, formName) {
    return this.utils.shouldShowErrors(fieldName, formName);
  }
 
  formSubmitClicked(){
    this.childDynamicFieldComponent.isSubmitted = true;
  }
  getErrorMessage(fieldName, formName) {
    return this.utils.getErrorMessage(fieldName, formName);
  }
  isSingleRow(field){
    const ww = document.body.clientWidth;
    if (ww > field.minWidth) {
       return false;
    }
    return true;
  }
}
